import { useTranslation } from 'react-i18next'
import { formatDateTime } from '@/lib/dateUtils'
import { useImpactChanges } from '../../impact-assessment'

/**
 * Every change made to an impact assessment, newest first: who, when, and what. Andrew, 14 Oct
 * 2026: "The user could go back and change an assessment" - so what it said earlier is kept.
 */
export function ImpactChanges({ assessmentId }: { assessmentId: number }) {
    const { t } = useTranslation()
    const { data: changes = [], isLoading } = useImpactChanges(assessmentId)
    if (isLoading) return <p className="text-sm text-muted-foreground">{t('common.loading', 'Loading...')}</p>
    if (changes.length === 0) return <p className="text-sm text-muted-foreground">{t('recoverRequests.impact.changes.none', 'Nothing has been changed yet.')}</p>
    return (
        <ol className="divide-y rounded-lg border bg-card" data-testid="impact-changes">
            {changes.map((c) => (
                <li key={c.id} className="grid gap-x-4 gap-y-0.5 px-4 py-2.5 text-sm sm:grid-cols-[11rem_10rem_1fr]">
                    <span className="tabular-nums text-muted-foreground">{c.changedAt ? formatDateTime(c.changedAt) : '—'}</span>
                    <span className="truncate text-muted-foreground">{c.changedByName || '—'}</span>
                    <span>{c.summary}</span>
                </li>
            ))}
        </ol>
    )
}
